import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

import Preloader from "../helper/Preloader";
import BannerOne from "../components/BannerOne";
import FeaturedOne from "../components/FeaturedOne";
import Problems from "../components/Problems";
import ServiceOne from "../components/ServiceOne";
import Faq from "../components/Faq";
import Testimonial from "../components/Testimonial";
import BrandSectionOne from "../components/BrandSectionOne";
import BecomeSellerTwo from "../components/BecomeSellerTwo";
import TamiasFor from "../components/TamiasFor";
import SellingOne from "../components/SellingOne";

const HomePage = ({ openModal, isModalOpen, handleOpenModal }) => {
  const { t, i18n } = useTranslation();

  const faqHy = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Թամիասը կարո՞ղ է ինտեգրվել այլ ծրագրերի հետ։",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Այո։ Համակարգը հեշտությամբ ինտեգրվում է ձեր առկա ERP, CRM, հաշվապահական և այլ ծրագրերի հետ՝ ապահովելով տվյալների միավորում և կրկնակի աշխատանքների բացառում։",
        },
      },
      {
        "@type": "Question",
        name: "Արդյոք համակարգը պահանջու՞մ է հատուկ տեխնիկական գիտելիքներ։",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Ոչ։ Թամիասը մշակված է պարզ, օգտագործողին հասանելի ինտերֆեյսով և չի պահանջում ՏՏ մասնագիտացված հմտություններ։",
        },
      },
      {
        "@type": "Question",
        name: "Տվյալների անվտանգությունն ապահովվա՞ծ է։",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Թամիասը համապատասխանում է միջազգային անվտանգության ստանդարտներին։ Տվյալները կոդավորված են, և մուտքերը վերահսկվում են RBAC մոդելով՝ ապահովելով GDPR և ISO համապատասխանություն։",
        },
      },
      {
        "@type": "Question",
        name: "Թամիասը հարմա՞ր է փոքր բիզնեսների համար։",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Այո։ Համակարգը ճկուն է թե՛ ծավալով, թե՛ գնով՝ հատուկ հարմարեցված փոքր և միջին բիզնեսների կարիքներին։",
        },
      },
      {
        "@type": "Question",
        name: "Թամիասը ներդնելու համար անհրաժեշտ է ՏՏ թիմ՞։",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Ոչ։ Թամիաս-ի ներդրումը իրականացվում է մեր փորձառու մասնագետների կողմից՝ ներառյալ ամբողջական ուսուցում և տեխնիկական աջակցություն։",
        },
      },
    ],
  };

  const faqEn = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Can Tamias be integrated with other software?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. The system easily integrates with your existing ERP, CRM, accounting, and other platforms, ensuring unified data and eliminating duplicate work.",
        },
      },
      {
        "@type": "Question",
        name: "Does the system require technical knowledge?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "No. Tamias is designed with a user-friendly interface and does not require any specialized IT skills.",
        },
      },
      {
        "@type": "Question",
        name: "Is my data secure with Tamias?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Tamias meets international data security standards. All data is encrypted and access is controlled via RBAC (Role-Based Access Control), ensuring GDPR and ISO compliance.",
        },
      },
      {
        "@type": "Question",
        name: "Is Tamias suitable for small businesses?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes. The platform is flexible in both scale and pricing, tailored to meet the needs of small and medium-sized businesses.",
        },
      },
      {
        "@type": "Question",
        name: "Do I need an IT team to implement Tamias?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "No. Our experienced team handles the implementation of Tamias, including full training and ongoing technical support.",
        },
      },
    ],
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(i18n.language === "hy" ? faqHy : faqEn)}
        </script>
      </Helmet>
      <section className="change-gradient">
        {/* Preloader */}
        <Preloader />

        {/* BannerOne */}
        <BannerOne
          setOpenGetDemoModal={() => openModal("getDemo")}
          setOpenCalendlyModal={() => openModal("calendly")}
        />

        {/* BrandSectionOne */}
        <BrandSectionOne />

        {/* FeaturedOne */}
        <div id="about">
          <FeaturedOne
            title={t("aboutSection.title")}
            descriptionLine1={t("aboutSection.desc")}
            direction={"text-left"}
            img={`/assets/images/thumbs/tamias-aboutImg.webp`}
            withoutPadding={false}
            isGradient={true}
            isContainer={true}
          />
        </div>

        {/* FeaturedOne */}

        {/* Problems */}
        <Problems direction={"text-right"} />

        {/* Solutions */}
        <ServiceOne />

        {/* Tools */}
        <SellingOne
          isModalOpen={isModalOpen}
          handleOpenModal={handleOpenModal}
        />

        {/* Testimonial */}
        <Testimonial />

        {/* BecomeSellerTwo */}
        <BecomeSellerTwo setOpenEbookModal={() => openModal("ebook")} />

        {/*Ո՞ւմ համար է նախատեսված Նազարը - Հաճախ տրվող հարցեր -*/}

        <TamiasFor direction={"text-right"} />

        {/* Faq */}
        <Faq />
      </section>
    </>
  );
};

export default HomePage;
